import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { selectIsMobile } from '~/store/modules/dimensions/selectors'

import Registration from '~/pages/Signup/SignUpV2/Registration'
import BillCreditPoster from '~/pages/Signup/SignUpV2/BillCreditPoster'
import CollapsiblePrimeGuaranteeCard from '~/features/CollapsiblePrimeGuaranteeCard'

const SignUpV2 = props => {
  const { promoCode, isPrimeGuarantee } = props

  const isMobile = useSelector(selectIsMobile)

  return (
    <div className="bg-white h-full flex rounded-md justify-between md:flex-row-reverse flex-col text-center md:fixed md:w-full">
      <div className="w-full md:w-1/2 shadow overflow-y-scroll">
        {isPrimeGuarantee ? (
          <div className="mb-0 md:mb-10">
            <CollapsiblePrimeGuaranteeCard />
          </div>
        ) : null}
        <div className={`md:pb-8 md:px-14 md:pb-8 ${isPrimeGuarantee ? '' : 'md:pt-16'}`}>
          <Registration
            isMobile={isMobile}
            promoCode={promoCode}
          />
        </div>
      </div>
      <div className="w-full md:w-1/2 mt-0">
        <BillCreditPoster isMobile={isMobile} />
      </div>
    </div>
  )
}

SignUpV2.propTypes = {
  promoCode: PropTypes.string,
  isPrimeGuarantee: PropTypes.bool.isRequired
}

SignUpV2.defaultProps = {
  promoCode: null,
}

const Memoized = React.memo(SignUpV2)
export default Memoized
